 <template>
  <div class="publicViewClass" style="padding-top:0">
    <div class="app-inner paperFx">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/testPapeList')">
            返回
            </div>
            </div>
            <div class="exam-title">
              <div class="exam-title-info flex align-cen">
                <b>{{list.paperName}}</b>
                <span class="title-extra" style="padding-left:10px">
                  <span>|</span>
                  考试时间：限制{{list.answerTimeLimit}}分钟
                </span>
              </div>
            </div>
            <div class="tabbable-custom">
              <div class="exam-analyze-ul flex align-cen">
                <div class="nav-tabs">
                  <el-tabs v-model="activeName" @tab-click="handleTab">
                     <el-tab-pane label="基本分析" name="1">
                       <div class="rdsdiv"></div>
                     <div class="paper-content" id="paperIDPd">
                         <div class="public-tit flex align-cen" ref="document">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i>  考试成绩分析
                            </div>
                        </div>
                        <div class="summaryOfTestPapers">
                          <div class="analysisTable">
                            <div class="analysisTable-title flex align-cen">
                              <span>试卷总分</span>
                               <span>考试次数</span>
                                <span>平均分</span>
                                 <span>最高分</span>
                                  <span>最低分</span>
                                   <span class="otherSpan">及格分（占总分{{analysisData.passmark}}%）</span>
                                    <span class="otherSpan">及格率</span>
                                    <span class="otherSpan">及格次数</span>
                            </div>
                            <div class="analysisTable-list flex align-cen">
                              <span>{{analysisData.paperScore}}</span>
                               <span>{{analysisData.examNum}}</span>
                                <span>{{analysisData.avgScore}}</span>
                                 <span>{{analysisData.maxScore}}</span>
                                  <span>{{analysisData.minScore}}</span>
                                   <span class="otherSpan">{{analysisData.passScore}}</span>
                                    <span class="otherSpan">{{analysisData.passRate}}%</span>
                                    <span class="otherSpan">{{analysisData.passNum}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="summaryOfTestPie">
                          <div class="exam-pr-pie">
                            <PieChart :option="PieChartOption" :pieID="1"></PieChart>
                        </div>
                        </div>
                        <div class="section-title">
                          分数段统计图
                        </div>
                          <div class="summaryOfTestPie summaryOfTestPie1">
                            <div class="group-score-segment flex align-cen">
                              <div class="left flex align-cen">
                                <div class="label">自定义分数段：</div>
                                <div class="group-score-segment-tags">
                                  <span class="tag" v-for="(item,index) in segmentData" :key="index"
                                  @click="openSorceSegment(item,'edit',index,1)"
                                  >
                                    {{item.description}} {{item.scope}}分 
                                    <i class="delet"  @click.stop="deletSorceSegment(item,1)"></i>
                                  </span>
                                </div>
                              </div>
                              <div class="right mft">
                                <div class="add-group-score-segment" @click="openSorceSegment('','add',-1,1)">
                                  增加自定义分数段
                                </div>
                              </div>
                            </div>
                          <div class="exam-pr-pie">
                           <BarChart :option="BarChartOption" :barID="'barID'" ></BarChart>
                        </div>
                        </div>
                          <div class="section-title">
                          各类题型正确率
                        </div>
                        <div class="App-tab" style="margin-top:16px">
                               <el-table
                                  :data="countQuestionTypeList"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="题型" align="center">
                                    <template slot-scope="scope">
                                      {{$util.getTopicType(scope.row.type)}}
                                    </template>
                                </el-table-column>
                                 <el-table-column label="题目数" align="center" prop="questionNum">
                                </el-table-column>
                                 <el-table-column label="总答题次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误次数" align="center" prop="errorNum">
                                </el-table-column>
                                <el-table-column label="正确次数" align="center" prop="rightNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center">
                                  <template slot-scope="scope">
                                    {{`${scope.row.errorRate}%`}}
                                  </template>
                                </el-table-column>
                                  <el-table-column label="正确率" align="center">
                                  <template slot-scope="scope">
                                    {{`${scope.row.rightRate}%`}}
                                  </template>
                                </el-table-column>
                               </el-table>
                        </div>
                        <div class="public-tit flex align-cen" style="margin-top:16px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i>  练习成绩分析
                            </div>
                        </div>
                          <div class="summaryOfTestPapers">
                          <div class="analysisTable">
                            <div class="analysisTable-title flex align-cen">
                              <span>试卷总分</span>
                               <span>考试次数</span>
                                <span>平均分</span>
                                 <span>最高分</span>
                                  <span>最低分</span>
                                   <span class="otherSpan">及格分（占总分{{analysisData1.passmark}}%）</span>
                                    <span class="otherSpan">及格率</span>
                                    <span class="otherSpan">及格次数</span>
                            </div>
                            <div class="analysisTable-list flex align-cen">
                              <span>{{analysisData1.paperScore}}</span>
                               <span>{{analysisData1.examNum}}</span>
                                <span>{{analysisData1.avgScore}}</span>
                                 <span>{{analysisData1.maxScore}}</span>
                                  <span>{{analysisData1.minScore}}</span>
                                   <span class="otherSpan">{{analysisData1.passScore}}</span>
                                    <span class="otherSpan">{{analysisData1.passRate}}%</span>
                                    <span class="otherSpan">{{analysisData1.passNum}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="summaryOfTestPie">
                          <div class="exam-pr-pie">
                            <PieChart :option="PieChartOption1" :pieID="2"></PieChart>
                        </div>
                        </div>
                        <div class="section-title">
                          分数段统计图
                        </div>
                          <div class="summaryOfTestPie summaryOfTestPie1">
                            <div class="group-score-segment flex align-cen">
                              <div class="left flex align-cen">
                                <div class="label">自定义分数段：</div>
                                <div class="group-score-segment-tags">
                                  <span class="tag" v-for="(item,index) in segmentData1" :key="index"
                                  @click="openSorceSegment(item,'edit',index,2)"
                                  >
                                    {{item.description}} {{item.scope}}分 
                                    <i class="delet"  @click.stop="deletSorceSegment(item,2)"></i>
                                  </span>
                                </div>
                              </div>
                              <div class="right mft">
                                <div class="add-group-score-segment" @click="openSorceSegment('','add',-1,2)">
                                  增加自定义分数段
                                </div>
                              </div>
                            </div>
                          <div class="exam-pr-pie">
                           <BarChart :option="BarChartOption1" :barID="'barID1'"></BarChart>
                        </div>
                        </div>
                                                  <div class="section-title">
                          各类题型正确率
                        </div>
                        <div class="App-tab" style="margin-top:16px">
                               <el-table
                                  :data="countQuestionTypeList1"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="题型" align="center">
                                    <template slot-scope="scope">
                                    {{$util.getTopicType(scope.row.type)}}
                                    </template>
                                </el-table-column>
                                 <el-table-column label="题目数" align="center" prop="questionNum">
                                </el-table-column>
                                 <el-table-column label="总答题次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误次数" align="center" prop="errorNum">
                                </el-table-column>
                                <el-table-column label="正确次数" align="center" prop="rightNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center">
                                  <template slot-scope="scope">
                                    {{`${scope.row.errorRate}%`}}
                                  </template>
                                </el-table-column>
                                  <el-table-column label="正确率" align="center">
                                  <template slot-scope="scope">
                                    {{`${scope.row.rightRate}%`}}
                                  </template>
                                </el-table-column>
                               </el-table>
                        </div>
                     </div>
                     </el-tab-pane>
                     <el-tab-pane label="试题分析" name="2">
                       <div class="rdsdiv"></div>
                        <div class="paper-content">
                           <div class="public-tit flex align-cen">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i>  正式考试分析
                            </div>
                        </div>
                      <div class="section-title">
                         错题排行
                        </div>
                         <div class="App-tab" style="margin-top:16px">
                          <el-table
                                  :data="errorRanking"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="标题" align="center">
                                     <template slot-scope="scope">
                                 <p v-html="scope.row.title" :class="scope.row.type == 9 ? 'clozeClass' : ''"></p>
                                  </template>
                                </el-table-column> 
                                  <el-table-column label="分类" align="center" prop="classifyName">
                                </el-table-column>
                                   <el-table-column label="标签" align="center" prop="tag">
                                </el-table-column>
                                 <el-table-column label="错误次数" align="center" prop="num">
                                </el-table-column>
                                <el-table-column label="考试次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center" prop="rate">
                                </el-table-column>
                          </el-table>
                         </div>
                             <div class="section-title">
                         对题排行
                        </div>
                         <div class="App-tab" style="margin-top:16px">
                          <el-table
                                  :data="rightRanking"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="标题" align="center">
                                     <template slot-scope="scope">
                                    <p v-html="scope.row.title" :class="scope.row.type == 9 ? 'clozeClass' : ''"></p>
                                  </template>
                                </el-table-column> 
                                  <el-table-column label="分类" align="center" prop="classifyName">
                                </el-table-column>
                                   <el-table-column label="标签" align="center" prop="tag">
                                </el-table-column>
                                  <el-table-column label="正确次数" align="center" prop="num">
                                </el-table-column>
                                <el-table-column label="考试次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center" prop="rate">
                                </el-table-column>
                          </el-table>
                         </div>
                                            <div class="public-tit flex align-cen" style="margin-top:16px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i>  练习考试分析
                            </div>
                        </div>
                      <div class="section-title">
                         错题排行
                        </div>
                         <div class="App-tab" style="margin-top:16px">
                          <el-table
                                  :data="errorRanking1"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="标题" align="center">
                                     <template slot-scope="scope">
                                   <p v-html="scope.row.title" :class="scope.row.type == 9 ? 'clozeClass' : ''"></p>
                                  </template>
                                </el-table-column> 
                                  <el-table-column label="分类" align="center" prop="classifyName">
                                </el-table-column>
                                   <el-table-column label="标签" align="center" prop="tag">
                                </el-table-column>
                                 <el-table-column label="错误次数" align="center" prop="num">
                                </el-table-column>
                                <el-table-column label="考试次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center" prop="rate">
                                </el-table-column>
                          </el-table>
                         </div>
                             <div class="section-title">
                         对题排行
                        </div>
                         <div class="App-tab" style="margin-top:16px">
                          <el-table
                                  :data="rightRanking1"
                                  border
                                  style="width: 100%"
                                  :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                  >
                                  <el-table-column label="标题" align="center">
                                     <template slot-scope="scope">
                                   <p v-html="scope.row.title" :class="scope.row.type == 9 ? 'clozeClass' : ''"></p>
                                  </template>
                                </el-table-column> 
                                  <el-table-column label="分类" align="center" prop="classifyName">
                                </el-table-column>
                                   <el-table-column label="标签" align="center" prop="tag">
                                </el-table-column>
                                  <el-table-column label="正确次数" align="center" prop="num">
                                </el-table-column>
                                <el-table-column label="考试次数" align="center" prop="answerNum">
                                </el-table-column>
                                 <el-table-column label="错误率" align="center" prop="rate">
                                </el-table-column>
                          </el-table>
                         </div>
                        </div>
                     </el-tab-pane>
                  </el-tabs>
                </div>
                <div class="mft right flex align-cen" v-if="activeName == '1'">
                  <span>搜索时间：</span>
                  <div class="datetimeform">
                    <el-date-picker
                    v-model="value2"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions2"
                    @change="classSelect"
                  >
                  </el-date-picker>
                  </div>
                 <div class="btn-set stastic-exam-actions" @click="openLog(1)">
                    查看练习记录
                  </div>
                   <div class="btn-set stastic-exam-actions" @click="openLog(0)">
                    查看考试记录
                  </div>
                  <div class="btn-set exportExamSa" @click="exportPDF">
                    导出统计分析(PDF)
                  </div>
                </div>
              </div>
              
            </div>
    </div>
                   <!-- 打开自定义分段 -->
      <el-dialog
  title="添加分数段"
  :visible.sync="centerDialogVisible"
  width="35%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible"
  @close="clsoeSorceSegment"
  >
    <div class="jBox-content">
      <div class="form-groups">
        <div class="group flex align-cen">
          <div class="label">分数段描述：</div>
          <div class="input-group">
            <el-input  v-model="groupText" clearable class="ipt1" placeholder="请输入分数段范围"></el-input>
          </div>
        </div>
        <div class="group flex align-cen">
          <div class="label">分数范围：</div>
          <div class="input-group flex align-cen">
             <el-input  v-model="score_segment_start" type="number" min="0" max="100"></el-input>
             <div class="input-group-addon"></div>
              <el-input  v-model="score_segment_end" type="number" min="0" max="100"></el-input>
          </div>
        </div>
      </div>
      <div class="authbtn flex align-cen">
        <el-button plain @click="clsoeSorceSegment"> 取消</el-button>
              <el-button type="primary" @click="submitScoreSegment">{{submitText}}</el-button>
    </div>
    </div>
      </el-dialog>
  </div>
</template>
<script>
import {getPaper,scoreAnalysis,segmentList,countQuestionType,questionRankList} from "@/api/index/index"  //获取试卷详情、考试成绩分析、分数段统计、各类题型正确率、试题排行
import PieChart from "../../../../components/pieTemolate/index.vue"; //饼图组件
import BarChart from "../../../../components/barTemplate/index.vue"; //柱状图图组件
import PdfLoader from '@/utils/html2pdf.js' 
export default {
    name:'scoreAnalysis',
    components:{
      PieChart,
      BarChart,
    },
    data() {
        return {
        rightRanking:[],
        errorRanking:[],
         rightRanking1:[],
        errorRanking1:[],
        practiceMode:'',
        countQuestionTypeList:[],
        countQuestionTypeList1:[],
        score_segment_index:'',
        submitText:'增加',
        score_segment_start:'0',
        score_segment_end:'0',
        groupText:'',
        centerDialogVisible:false,
        list:{},
        activeName:'1',
        value2:'',
        start_time:'',
        end_time:'',
        analysisData:{},
        analysisData1:{},
        segmentData:[],
        segmentData1:[],
        segmentArray:[],
        segmentArray1:[],
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },    
        PieChartOption:{},
        BarChartOption:{},
        PieChartOption1:{},
        BarChartOption1:{},
        }
    },
    created () {
        if(this.activeName == '1'){
           this.getPaperDetail()
         this.getScoreAnalysis(0)
         this.getCountQuestionType(0)
        this.getScoreAnalysis(1)
        this.getCountQuestionType(1)
        }else{
          this.getQuestionRankList(0,0)
          this.getQuestionRankList(0,1)
           this.getQuestionRankList(1,0)
          this.getQuestionRankList(1,1)
        }
    },
    methods: {
       // 打开考试记录
      openLog(practiceMode){
        this.$router.push({
          name:'examLog',
          query:{
            practiceMode:practiceMode,
            paperId:this.$route.query.id
          }
        })
      },
      // 导出为pdf
      exportPDF(){
           // 获取需要导出的局部内容  
            const content = document.getElementById('paperIDPd'); 
             this.pdfDownLoader = new PdfLoader(content, 'fileName', 'summaryOfTestPie')  // fileName -->导出文件名,  question-table -->防止被截断的class名
             this.pdfDownLoader.outPutPdfFn('全文统计分析报告')
      },
      // tab切换
      handleTab(){
        if(this.activeName == '1'){
           this.getPaperDetail()
         this.getScoreAnalysis(0)
         this.getCountQuestionType(0)
        this.getScoreAnalysis(1)
        this.getCountQuestionType(1)
        }else{
          this.getQuestionRankList(0,0)
          this.getQuestionRankList(0,1)
           this.getQuestionRankList(1,0)
          this.getQuestionRankList(1,1)
        }
      },
      // 试题排行分析
      getQuestionRankList(type,doRight){
          let params = {
          id:this.$route.query.id,
          practiceMode:type,
          startTime:this.start_time || '',
          endTime:this.end_time || '',
          doRight:doRight
        }
        questionRankList(params)
        .then(res =>{
          if(type == 0){
            this[doRight == 0 ? 'errorRanking' : 'rightRanking'] = res.data
          }else{
             this[doRight == 0 ? 'errorRanking1' : 'rightRanking1'] = res.data
          }
          
        })
      },
      // 获取各类正确率接口
      getCountQuestionType(type){
         let params = {
          id:this.$route.query.id,
          practiceMode:type,
          startTime:this.start_time || '',
          endTime:this.end_time || ''
        }
        countQuestionType(params)
        .then(res =>{
         this[type == 0 ? 'countQuestionTypeList' : 'countQuestionTypeList1'] = res.data
        })
      },
      // 删除自定义分段
      deletSorceSegment(data,index){
        this.$confirm('确定要删除吗？', '删除分数段', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let arr = []
        arr.push(data)
        let delet= this[index == 1 ? 'segmentArray' : 'segmentArray1'].filter(item=>!arr.some(ele=>ele.scope===item.scope)) 
        this[index == 1 ? 'segmentArray' : 'segmentArray1'] = delet
        this.getSegment(index)
        })
      },
      // 添加分数段
      submitScoreSegment(){
        if(this.score_segment_index==-1){
             if(Number(this.score_segment_start < 0)) return this.$util.Notifi('起始范围不能小于0','error','fa-exclamation-circle')
             if(Number(this.score_segment_start) >= Number(this.score_segment_end) ) return this.$util.Notifi('请输入符合规则的范围','error','fa-exclamation-circle')
      this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'].push({
            description:this.groupText,
            scope:`${this.score_segment_start}-${this.score_segment_end}`
          })
        // 排序
       let sortArr = []
       let totalarr = []
        for (let key in this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1']) {
          totalarr = this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'][key].scope.split('-')
          sortArr.push({
            description:this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'][key].description,
            scope:this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'][key].scope,
            total:Number(totalarr[0]) + Number(totalarr[1])
          })
        }
        sortArr.sort((a, b) => a.total - b.total);  
        this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'] = sortArr.map(obj => {  
            const newObj = Object.assign({}, obj); // 创建原始对象的浅拷贝  
            delete newObj.total; // 删除浅拷贝对象的total属性  
            return newObj; // 返回删除total属性的新对象  
        }); 
        }else{
          this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'][this.score_segment_index].description = this.groupText
          this[this.practiceMode == 1 ? 'segmentArray' : 'segmentArray1'][this.score_segment_index].scope = `${this.score_segment_start}-${this.score_segment_end}`
        }
       this.getSegment(this.practiceMode)
      this.centerDialogVisible = false
      this.groupText = ''
      this.score_segment_start='0'
      this.score_segment_end='0'
      },
    // 关闭输入框内容
    clsoeSorceSegment(){
      this.centerDialogVisible = false
      this.groupText = ''
      this.score_segment_start='0'
      this.score_segment_end='0'
    },
      // 打开分数段弹窗
      openSorceSegment(data,type,index,practiceMode){
        type == 'add' ? this.submitText='增加':this.submitText='保存'
        this.score_segment_index = index
        this.practiceMode = practiceMode
        if(data.scope){
          this.groupText = data.description
          let arr = data.scope.split("-")
          this.score_segment_start=arr[0]
          this.score_segment_end=arr[1]
        }
        this.centerDialogVisible = true
      },
      getSegment(type){
        let params = {
          paperId:this.$route.query.id,
          practiceMode:type == 1 ?"0" : '1',
          startTime:this.start_time || '',
          endTime:this.end_time || '',
          segments:type == 1 ? this.segmentArray : this.segmentArray1
        }
        segmentList(params)
        .then(res =>{
          if(res.code == 0){
           type == 1 ?  this.segmentData = res.data :  this.segmentData1 = res.data
            let xData = []
            let seriesData = []
            for (let key in res.data) {
              xData.push(res.data[key].description)
              seriesData.push({
                name:res.data[key].description,
                value:Number(res.data[key].count),
                scope:res.data[key].scope,
                 itemStyle: {
                    color: res.data[key].description.includes('不及格') ? '#FF6969': res.data[key].description.includes('及格') ? '#699DFF' : '#409eff'
                  }
              })
            }
           
            this[type == 1 ? 'BarChartOption' : 'BarChartOption1'] = {
               tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                 formatter:function(params){
                    var str = '';
                     str = `${params[0].data.name}</br>分数范围：${params[0].data.scope}</br>人数：${params[0].data.value}`
                     return str
                  }
              },
               legend: {
              data: xData
            },
            
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                  {
                    type: 'category',
                    data: xData,
                    axisTick: {
                      alignWithLabel: true
                    }
                  }
                ],
               yAxis: [
                  {
                    type: 'value',
                    position: 'middle',
                    name:'人数',
                    min:0,
                    max:type ==1 ? this.analysisData.examNum : this.analysisData1.examNum
                  }
                ],
               series: [
                  {
                    
                    type: 'bar',
                    barWidth: '10%',
                    data: seriesData
                  },
                ]
            }
          }
        })
      },
      // 考试成绩分析
      getScoreAnalysis(type){
        let params = {
          id:this.$route.query.id,
          practiceMode:type,
          startTime:this.start_time || '',
          endTime:this.end_time || ''
        }
        scoreAnalysis(params)
        .then(res =>{
          this[type == 0 ? 'analysisData' : 'analysisData1'] = res.data
          this[type == 0 ? 'segmentArray' : 'segmentArray1'] = [
            {
              scope:`0-${Number(res.data.passScore)}`,
              description:'不及格'
            },
            {
             scope:`${Number(res.data.passScore) + 1}-${res.data.paperScore}`,
            description:'及格' 
            }
          ]
          this.getSegment(type == 0 ? 1 : 2)
              let srdata = [
                        { value: Number(res.data.flunkRate), name: '不及格率',num:Number(res.data.flunkNum) },
                        { value: Number(res.data.passRate), name: '及格率',num:Number(res.data.passNum)  },
                      ]
              this[type == 0 ? 'PieChartOption' : 'PieChartOption1'] = {
                title: {
                  text: '考试及格率',
                  left: 'center'
                },
                tooltip: {
                  trigger: 'item',
                  formatter:function(params){
                    var str = '';
                     str = `${params.data.name}</br>次数：${params.data.num}</br>比例：${params.data.value}%`
                     return str
                  }
                },
                legend: {
                orient: 'horizontal',
                left: 'auto'
              },
              color: ['#FF6969','#699DFF'],
                series: [
                    {
                      name: '考试成绩',
                      type: 'pie',
                      radius: '50%',
                      data: srdata,
                      emphasis: {
                        itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                      }
                    }
                  ]
              }
        })
      },
      // 时间筛选事件
      classSelect(){
        if(this.value2){
          this.start_time = this.value2[0]
          this.end_time = this.value2[1]
        }else{
          this.value2 = ''
          this.start_time = ''
          this.end_time = ''
        }
        this.activeName = '1'
        this.handleTab()
      },
        // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.id},'get')
            .then(res =>{
              this.list = res.data
            })
            .catch(err =>{})
        },
    }
}
</script>
<style lang="scss" scoped>
.section-title{
  margin-top: 25px;
  font-size: 16px;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
    font-weight: 700;
    text-indent: 16px;
    position: relative;
}
.section-title::before{
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background-color: #409eff;
    border-radius: 2px;
}
.jBox-content{
  padding: 20px 77px 24px;
  .authbtn{
    margin-top: 46px;
    justify-content: center;
  }
  .group{
        margin-bottom: 17px;
        .label{
          margin: 0 12px 0 0;
          width: 130px;
          text-align: right;
        }
        .input-group{
          width: 300px;
          height: 40px;
          .input-group-addon{
            min-width: unset;
            display: inline-block;
            width: 50px;
            height: 2px;
            margin: 0 12px;
            background-color: #999999;
            vertical-align: middle;
            border-color: #e5e5e5;
            background: #e5e5e5;
          }
        }
  }
}
.paperFx{
  .exam-title{
    position: relative;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    cursor: default;
    b{
      font-weight: bolder;
    }
    .title-extra{
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
  }
  .tabbable-custom{
    background-color: #f3f4f8;
    position: relative;
    .exam-analyze-ul{
     padding: 0 24px 20px;
    border-radius: 0 0 10px 10px!important;
    background-color: #fff;
    .nav-tabs{
    margin-top: 20px;
    margin-bottom: 0;
    border-bottom: 0;
    background-color: #fff;
    border-radius: 10px 10px 0 0!important;
    }
      .rdsdiv{
        height: 20px;
        background: #f7f8fa;
      }
    .paper-content{
        background: #fff;
        padding: 16px;
        border-radius: 5px;
        margin-bottom: 80px;
        .summaryOfTestPapers{
          .analysisTable{
            margin-top: 20px;
            .analysisTable-title{
              height: 40px;
              line-height: 40px;
              background: #eeeeee;
              span{
                width: 10.4%;
                text-align: center;
              }
              .otherSpan{
                width: 16%;
              }
            }
            .analysisTable-list{
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #efefef;
               span{
                width: 10.4%;
                text-align: center;
              }
              .otherSpan{
                width: 16%;
              }
            }
          }
        }
        .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
        .summaryOfTestPie1{
          margin: 10px 0;
          .group-score-segment{
            margin-bottom: 20px;
            .label{
              color: #333;
              font-size: 16px;
            }
            .group-score-segment-tags{
              .tag{
                position: relative;
                margin-right: 12px;
                padding: 6px 30px;
                font-size: 14px;
                color: #666;
                background-color: #f3f4f8;
                border-radius: 4px!important;
                cursor: pointer;
                .delet{
                  position: absolute;
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  width: 14px;
                  height: 14px;
                  background: url('../../../../assets/images/delete.png') no-repeat center;
                  display: inline-block;
                  
                }
              }
            }
            .add-group-score-segment{
              margin-right: 10px;
              cursor: pointer;
              background-color: white!important;
            color: #333333;
            border: 1px solid #cacaca;
            padding: 7px 20px;
            border-radius: 4px!important;
            font-size: 14px;
            }
          }
        }
    }
    .right{
      .btn-set{
        min-width: 120px;
        margin-right: 16px;
        cursor: pointer;
        color: #409eff;
        border: 1px solid #409eff;
        padding: 7px 10px;
        border-radius: 4px!important;
        text-align: center;
      }
      .exportExamSa{
        border: none;
        background: #409eff;
        color: #fff;
      }
    }
    }
  }
}
::v-deep{
  .input-group{
          .ipt1{
            .el-input__inner{
              max-width: 100% !important;
              background-color: #ffffff;
              border-radius: 4px;
              border: solid 1px #e6e6e6;
            }
          }
        }
  .el-tabs__content{
    position: absolute;
    left: -16px;
    width: calc(100% + 32px);
  }
  .nav-tabs{
    .el-tabs__nav-wrap::after{
      background: none !important;
    }
    .el-tabs__item{
     width: 112px;
     text-align: center;
    font-size: 14px;
    color: #999;
    padding: 0;
    }
  .is-active{
    color: #409eff !important;
  }
  .el-tabs__active-bar{
    width: 112px !important;
  }
  }
  .el-input__inner{
    max-width: 250px;
    margin-right: 16px;
  }
       .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>